import { Mail } from "../models/Mail";
import { MailLog } from "../models/MailLog";

export const mapStatus = (status?: string): string | undefined => {
	switch (status?.toLowerCase()) {
		case "delivery":
			return "Delivered";
		case "send":
			return "Sent";
		case "bounce":
			return "Bounced";
		case "reject":
			return "Rejected";
		case "open":
			return "Opened";
		case "click":
			return "Opened & Clicked";
		case "mail entity created":
			return "Mail Created";
		default:
			break;
	}
	return status;
};

export const isSuccessStatus = (status?: string): boolean => {
	switch (status?.toLowerCase()) {
		case "delivery":
			return true;
		case "send":
			return true;
		case "bounce":
			return false;
		case "reject":
			return false;
		case "open":
			return true;
		case "click":
			return true;
		case "queued":
			return true;
		case "mail entity created":
			return true;
		default:
			break;
	}
	return false;
};

export const getLatestStatus = (mail: Mail): string => {
	return [...mail.logs].sort(
		(a: MailLog, b: MailLog) =>
			new Date(b.dateTimeStamp).getTime() - new Date(a.dateTimeStamp).getTime()
	)[0].status;
};
